import ProductsFilters from './FiltersPage';

export default ProductsFilters;
